import { GetS3UrlForDesktopDownloadResponse } from "@/backend/express/controllers/veriform-desktop/veriformDesktopController";
import { Client } from "./client";

export class VeriformController {
  client: Client;

  constructor() {
    this.client = new Client();
  }

  public async gets3UrlForDesktopDownload(): Promise<GetS3UrlForDesktopDownloadResponse> {
    return this.client.read('/api/veriform-desktop/getS3UrlForDesktopDownload');
  }
}
